// extracted by mini-css-extract-plugin
export var actions = "_mv-g";
export var benefitCard = "_mv-b";
export var benefitIcon = "_mv-d";
export var benefitLabel = "_mv-f";
export var benefits = "_mv-a";
export var benefitsSection = "_mv-8";
export var bodyText = "_mv-7";
export var closeButton = "_mv-2";
export var content = "_mv-3";
export var eyebrow = "_mv-4";
export var heading = "_mv-5";
export var image = "_mv-i";
export var imagePanel = "_mv-h";
export var modal = "_mv-0";
export var offerCard = "_mv-c";
export var offerIcon = "_mv-e";
export var sectionLabel = "_mv-9";
export var shell = "_mv-1";
export var title = "_mv-6";